import { Box, Divider, Typography } from '@mui/material';

type Props = {
  title: string;
  subtitle?: string;
  text?: string;
};

const GenericSidebarHeader = ({ title, subtitle, text }: Props) => {
  return (
    <>
      <Box p={2} sx={{ background: (theme) => theme.palette.primary.background }}>
        <Typography variant="h3">{title}</Typography>
        {subtitle && (
          <Typography variant="h4" sx={{ color: 'secondary.dark' }}>
            {subtitle}
          </Typography>
        )}
        {text && <Typography>{text}</Typography>}
      </Box>
      <Divider />
    </>
  );
};

export default GenericSidebarHeader;
